<template>
  <div class="question-table">
    <AutoTable :data="questions" row-key="uuid" />
  </div>
</template>

<script>
import AutoTable from "./autoTable.js";
console.log("rerender");
export default {
  components: {
    AutoTable
  },
  props: {
    examQuestionType: {
      type: String,
      default: ""
    },
    questionList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      questions: []
    };
  },
  watch: {
    questionList() {
      this.questions = this.questionList.filter(
        ele => ele.examQuestionType == this.examQuestionType
      );
    },
    examQuestionType(val) {
      this.questions = this.questionList.filter(
        ele => ele.examQuestionType == val
      );
    }
  }
};
</script>
